import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const ContributionTable = ({ showTable, historyData,shouldGenerateReport,
  setShouldGenerateReport,calcDone }) => {
  const { textData } = useLocale();
  const [reportData, setReportData] = useState([]);
  const {
    annualSalary,
    estimatedReturn,
    monthlyContribution,
    salaryRise,
    currentAge,
    retirementAge,
    returnRate,
    currentBalance,
    employerMatch,
    salaryLimit,
  } = useSelector((state) => state.contributionCalculator);

  useEffect(() => {
    if (historyData) {
      generateHistoryreport();
    } 
  }, [
    showTable,
    annualSalary,
    estimatedReturn,
    monthlyContribution,
    salaryRise,
    currentAge,
    retirementAge,
    returnRate,
    currentBalance,
    employerMatch,
    salaryLimit,
    historyData,
  ]);

   useEffect(() => {
      if (shouldGenerateReport) {
        generateReportData();
        setShouldGenerateReport(false);
      }else if (!calcDone) {
    setReportData([]); 
    generateHistoryreport();
  }
}, [shouldGenerateReport, calcDone, historyData]);


  const generateHistoryreport = () => {
    if (!Array.isArray(historyData) || historyData.length === 0) {
      return;
    }
    const contributionData = historyData[0];

    const salary = Number(contributionData.totalSalary);
    const contributionRate = Number(contributionData.totalContribution);
    const age = Number(contributionData.age);
    const retireAge = Number(contributionData.retiremenetAge);
    const returnRateNum = Number(contributionData.totalReturn);
    const startingBalance = Number(contributionData.balance);
    const matchRate = Number(contributionData.matchRate);
    const matchLimit = Number(contributionData.matchLimit);

    const yearsToGrow = retireAge - age;
    const months = yearsToGrow * 12;
    const monthlyReturn = Number((returnRateNum / (12 * 100)).toFixed(6));
  
    const monthlyEmployee = Number(((salary * contributionRate) / 12).toFixed(2));
    const monthlyEmployer = Number((((salary * matchLimit) * matchRate) / 12).toFixed(2));
    const monthlyTotal = monthlyEmployee + monthlyEmployer;
  
    let report = [];
    let balanceWithMatch = startingBalance;
    let totalContribution = 0;
    let totalEmployeeContribution = 0;
    let totalEmployerContribution = 0;
  
    for (let year = 1; year <= yearsToGrow; year++) {
      const currentAgeYear = age + year;
  
      // Update balance for 12 months
      for (let month = 1; month <= 12; month++) {
        balanceWithMatch = balanceWithMatch * (1 + monthlyReturn) + monthlyTotal;
      }
  
      const yearlyEmployee = monthlyEmployee * 12;
      const yearlyEmployer = monthlyEmployer * 12;
  
      totalEmployeeContribution += yearlyEmployee;
      totalEmployerContribution += yearlyEmployer;
      totalContribution = totalEmployeeContribution + totalEmployerContribution;
  
      report.push({
        age: currentAgeYear,
        salary: salary,
        contribution: yearlyEmployee,
        employerMatch: yearlyEmployer,
        cumulativeamount: balanceWithMatch,
        totalContribution: totalContribution,
      });
    }
  
    setReportData(report);
  };
  const generateReportData = () => {
    const salary = Number(annualSalary);
    const contributionRate = Number(monthlyContribution) / 100;
    const age = Number(currentAge);
    const retireAge = Number(retirementAge);
    const returnRateNum = Number(returnRate);
    const startingBalance = Number(currentBalance); // renamed
    const matchRate = Number(employerMatch) / 100;
    const matchLimit = Number(salaryLimit) / 100;
  
    const yearsToGrow = retireAge - age;
    const months = yearsToGrow * 12;
    const monthlyReturn = Number((returnRateNum / (12 * 100)).toFixed(6));
  
    const monthlyEmployee = Number(((salary * contributionRate) / 12).toFixed(2));
    const monthlyEmployer = Number((((salary * matchLimit) * matchRate) / 12).toFixed(2));
    const monthlyTotal = monthlyEmployee + monthlyEmployer;
  
    let report = [];
    let balanceWithMatch = startingBalance;
    let totalContribution = 0;
    let totalEmployeeContribution = 0;
    let totalEmployerContribution = 0;
  
    for (let year = 1; year <= yearsToGrow; year++) {
      const currentAgeYear = age + year;
  
      // Update balance for 12 months
      for (let month = 1; month <= 12; month++) {
        balanceWithMatch = balanceWithMatch * (1 + monthlyReturn) + monthlyTotal;
      }
  
      const yearlyEmployee = monthlyEmployee * 12;
      const yearlyEmployer = monthlyEmployer * 12;
  
      totalEmployeeContribution += yearlyEmployee;
      totalEmployerContribution += yearlyEmployer;
      totalContribution = totalEmployeeContribution + totalEmployerContribution;
  
      report.push({
        age: currentAgeYear,
        salary: salary,
        contribution: yearlyEmployee,
        employerMatch: yearlyEmployer,
        cumulativeamount: balanceWithMatch,
        totalContribution: totalContribution,
      });
    }
  
    setReportData(report);
  };
  
  

  const columns = [
    { key: "age", label: textData.tableLabels.age, format: (value) => value },
    {
      key: "salary",
      label: `${textData.tableLabels.salary} (${textData.currency})`,
      format: (value) =>
        `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "contribution",
      label:`${textData.tableLabels.contribution} (${textData.currency})`,
      format: (value) =>
        `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "employerMatch",
      label: `${textData.tableLabels.employerMatch} (${textData.currency})`,
      format: (value) =>
        `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "cumulativeamount",
      label: `${textData.tableLabels.cumulativeamount} (${textData.currency})`,
      format: (value) =>
        `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "totalContribution",
      label: `${textData.tableLabels.totalContribution} (${textData.currency})`,
      format: (value) =>
        `${FormatIndianNumber(Math.round(value))}`,
    },
  ];

  // Debug render

  return (
    <TableLayout
      showTable={showTable}
      title={`${textData.filterDropDown.contributionCalc} ${textData.report}`}
      data={reportData}
      columns={columns}
      analyticsEventName="download_pl_report"
      reportTitle={textData.reportTitle.contribution}
      fileName="contribution_detail"
    />
  );
};

export default ContributionTable;
